module.exports = __webpack_public_path__ + "img/b6b74474fc7636711f9fe69ab62df45d.png";